import React from 'react';
import {OrbitComponent} from "../../base-components/orbit-component/orbit-component";
import {observer} from "mobx-react";
import {TippingHistoryDaysSelectorComponent} from "./history-days-selector/tipping-history-days-selector.component";
import {TippingHistoryHeaderBox} from './boxes/tipping-history-header.box';
import {TippingHistoryHeaderFlexGrowBox} from './boxes/tipping-history-header-flex-grow.box';
import {ITippingHistoryViewModel} from '../../../services/tipping-history/models/tipping-history-view-model.interface';

interface TippingHistoryHeaderComponentProps {
    viewModel: ITippingHistoryViewModel;
}

export const TippingHistoryHeaderComponent = observer(
    class TippingHistoryHeaderComponent extends OrbitComponent<TippingHistoryHeaderComponentProps> {
        private _onDaysSelected = (daysNumber: number) => {
            this.props.viewModel.setNumberOfHistoryDays(daysNumber);
        }

        render() {
            return (
                <TippingHistoryHeaderBox>
                    {!this.services.mediaQuery.sAndBelow && <TippingHistoryHeaderFlexGrowBox/>}
                    {
                        <TippingHistoryDaysSelectorComponent daysIntervals={this.props.viewModel.daysIntervals}
                                                             onDaysSelected={this._onDaysSelected}/>
                    }

                </TippingHistoryHeaderBox>
            )
        }
    }
);